import React from 'react';
import { styled } from '../../../stitches.config';

import Box from '../Box'
import { Wrapper as Wrap } from "./ACommonStyles"
import { getPcsUrls } from "./AHelpers"

export default props => {
	const size = window.innerWidth > 992 ? "sm" : "lg";
	const aspectRatio = { mobile: 0.92, desktop: 1.097 };
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);
	const isDesktop = window.innerWidth >= 996;

	return (
		<section className="container">
			<Wrapper className="row" pcs={pcs}>
				<div className="col-xs-12 col-md-6">
					<Box {...props} id="b5" type="BTextOnPicture" settings={props.settings.b5} aspectRatio={aspectRatio} classes="" />
				</div>
				<div className="col-xs-12 col-md-3 column-wrapper">
					{
						isDesktop ?
							<Box {...props} id="b6" type="BPhotoOnTop" settings={props.settings.b6} classes="" />
							:
							<Box {...props} id="b6" type="BPhotoOnLeft" settings={props.settings.b6} classes="" />
					}
					<Box {...props} id="b7" type="BPhotoOnLeft" settings={props.settings.b7} classes="" />
				</div>
				<div className="col-xs-12 col-md-3">
					<Box {...props} id="b1" type="BPhotoOnLeft" settings={props.settings.b1} classes="" />
					<Box {...props} id="b2" type="BPhotoOnLeft" settings={props.settings.b2} classes="" />
					<Box {...props} id="b3" type="BPhotoOnLeft" settings={props.settings.b3} classes="" />
					<Box {...props} id="b4" type="BPhotoOnLeft" settings={props.settings.b4} classes="" />
				</div>
			</Wrapper>
		</section>
	);
}

const Wrapper = styled(Wrap, {
	"@media (min-width: 992px)": {
		display: "flex",
		flexDirection: "row",
		"> div:nth-child(1)": { order: 2 },
		"> div:nth-child(2)": { order: 1 },
		"> div:nth-child(3)": { order: 3 },
		".column-wrapper": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-between"
		}
	}
});
